import { Typography } from "@mui/material";
import { styled, Box } from "@mui/system";
import { HHNTheme } from "hhn-commons";
import theme from "../../../theme";

export const ReportContainer = styled(Box)`
  background: white;
  border: 1px solid ${theme.palette.grey[200]};
  border-radius: 6px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.palette.grey[50]};
  }
`;

export const FileIconContainer = styled(Box)`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const PdfIconContainer = styled(FileIconContainer)`
  background-color: ${HHNTheme.errorContainer};
  color: ${HHNTheme.error};
`;

export const DocIconContainer = styled(FileIconContainer)`
  background-color: ${HHNTheme.primaryContainer};
  color: ${HHNTheme.primary};
`;

export const XlsIconContainer = styled(FileIconContainer)`
  background-color: ${HHNTheme.successContainer};
  color: ${HHNTheme.success};
`;

export const ImageIconContainer = styled(FileIconContainer)`
  background-color: ${HHNTheme.warningContainer};
  color: ${HHNTheme.warning};
`;

export const OtherIconContainer = styled(FileIconContainer)`
  background-color: ${theme.palette.grey[100]};
  color: ${theme.palette.grey[600]};
`;

export const ReportInfo = styled(Box)`
  flex: 1;
  min-width: 0;
`;

export const ReportName = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.palette.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
